const skills = [
  { name: 'ReactJs', rate: '8' },
  { name: 'Redux', rate: '7' },
  { name: 'JavaScript', rate: '9' },
  { name: 'HTML', rate: '10' },
  { name: 'CSS', rate: '10' },
  { name: 'SCSS', rate: '10' },
  { name: 'Wordpress', rate: '7' },
  { name: 'Bootstrap', rate: '10' }
];

export { skills };
